import React, { Fragment, useState } from 'react'
import TimeCounter from './../../../../commons/components/Award/TimeCounter'
import PopComponent from './../../../../commons/components/Popup/PopupComponent'
import moment from 'moment-timezone'
import { formatTimeZone, priceFormat } from '../../../../utils/helpers'
import { TIME_ZONE, IMAGE_PREVIEW_FORMAT } from '../../../../commons/constans/moment'

const Item = ({ entry, selected, index, onSelect, active, setImageSelected, rank = null }) => (
  <div
    className={`search-voting__list__item${active ? ' active' : ''}${(index > 10 && !rank && !entry?.photo?.photo_url?.thumbnail) ? ' item_no_img' : ''}`}
  >
    <div
      className="d-flex align-items-center search-voting__list__item__col"
      onClick={() => setImageSelected(entry.photo)}>
      <label className="search-voting__list__item__rank">
        {index}
      </label>
      <img
        className="search-voting__list__item__avatar"
        src={entry?.photo?.photo_url?.thumbnail}
      />
    </div>
    <div
      className="search-voting__list__item__col"
      onClick={() => setImageSelected(entry.photo)}>
      <label className="search-voting__list__item__name text-truncate pl-2">
        {entry?.user?.nickname}
      </label>
    </div>
    <div className="d-flex align-items-center search-voting__list__item__col justify-content-end">
      <label className="search-voting__list__item__point pr-2">
        {priceFormat(entry?.total_vote)}
      </label>
      <button
        className={`btn search-voting__list__item__vote-btn${selected ? ' btn-active' : ''}`}
        onClick={() => onSelect(entry)}>
        투표
      </button>
    </div>
  </div>
)

const VoteList = ({entries = [], onSelect = () => {}, selected = [], rank = null}) => {
  const [isShowImage, setShowImage] = useState(false)
  const [imageSelected, setImageSelected] = useState(null)

  const handleShowImage = (image) => {
    setShowImage(true)
    setImageSelected(image)
  }

  const _handleCloseModal = () => {
    setShowImage(false)
    setImageSelected(null)
  }
  return (
    <>
      <div className="search-voting__list">
        {entries.map((entry, key) => (
          <Item
            key={key}
            entry={entry}
            selected={selected.find(e => e?.id === entry?.id)}
            index={rank ?? entry.rank ?? key + 1}
            onSelect={onSelect}
            active={!!rank}
            setImageSelected={handleShowImage}
            rank={rank}
          />
        ))}
      </div>
      {imageSelected && (
        <PopComponent
          id={"MD6"}
          show={isShowImage}
          handleClose={_handleCloseModal}
          style={{ width: "calc(100vw - 50px"}}
          // bodyStyle={{height: "80vh"}}
          headingStyle={{borderBottom: "2px solid rgb(17 17 17 / 20%)"}}
          title={"이미지 상세보기"}
        >
          <div className="modal-voting-avatar-user d-flex justify-content-center">
            <div className="modal-voting-avatar-user__item">
              <img
                className="modal-voting-avatar-user__item__avatar"
                src={imageSelected?.photo_url?.original}
                alt=""
              />
              <p className="modal-voting-avatar-user__item__bthday">
                {formatTimeZone(imageSelected?.created_at)}
              </p>
            </div>
          </div>
        </PopComponent>
      )}
    </>
  )
}

export default VoteList;
